import React from 'react';
import './index.less';
export default function PopupHeader(props) {
  const {
    headerLeft = '取消',
    title,
    headerRight = '确定',
    onLeftClick,
    onRightClick
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "cc-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cc-header__left",
    onClick: headerLeft ? onLeftClick : null
  }, headerLeft), /*#__PURE__*/React.createElement("div", {
    className: "cc-header__title ellipsis"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "cc-header__right",
    onClick: headerRight ? onRightClick : null
  }, headerRight));
}